const deleteAddDocumentCompanies = {
  toastr: 'Documento deletado',
  toastr1: 'O documento foi deletado com sucesso'
};

export default deleteAddDocumentCompanies;
